import { Student } from '../types';

export const STUDENTS: Student[] = [
  "고은희", "김미전", "김사라", "김영란", "김옥자", "김정화", "김태희", 
  "김필선", "김혜진", "김희용", "도민자", "박은선", "박진환", "백현주", 
  "신황숙", "이동은", "이영선", "장경옥", "정명희", "최경자", "최금철", 
  "홍성희", "홍현정", "황순임", "김민서", "김선령", "김성희", "김정원", 
  "박기성", "박상현", "박시현", "서혜원", "손미숙", "송민경", "안국빈", 
  "우정운", "윤정아", "이명용", "이영", "이정근", "이주영", "이현주", 
  "임선미", "장재훈", "전명란", "전종숙", "전혜진", "조윤재", "최경갑", 
  "최성희", "최수정"
].map((name, index) => ({
  id: `student-${index + 1}`,
  name,
  parkingNumber: '',
  hasParkingSpace: false,
  registrationDate: new Date().toISOString().split('T')[0],
  isRegistered: false,
  assignedTable: undefined,
})); 